

let doc:any;

export function initDoc(db) {
    doc = db.table('doc')
}

/** 新增 */
export function addDoc(id, data) {
    doc.add({ id, data })
}

/** 修改 */
export function editDoc(id, data,name) {
    return doc.put({ id, data ,name})
}

/** 删除 */
export function delDoc(id) {
    doc.delete(id)
}

/** 根据id查询笔记 */
export function getDoc(id) {
    return doc.get(id)
}

export function getDocList(){
    return doc.toArray();
}